module.exports = __webpack_public_path__ + "img/timeline_miscevent-9.5f65520e.jpg";